<template>
  <div>
    <h1>{{ $t("settings.project.list") }}</h1>
    <v-row style="margin-bottom: 15px">
      <v-col cols="3">
        <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search" />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="projects"
      :footer-props="{ 'items-per-page-options': [{ text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }] }"
      :search="search"
      class="elevation-1"
      hide-default-footer
    >
      <template #item="props">
        <tr>
          <td class="text-left">
            {{ props.item.name }}
          </td>
          <td class="text-left">
            {{ props.item.external_customer_name }}
          </td>
          <td class="text-left">
            {{ props.item.order_number }}
          </td>
          <td class="text-left">
            <span v-if="props.item.is_enabled === 1">{{ $t("global.yes") }}</span>
            <span v-if="props.item.is_enabled === 0">{{ $t("global.no") }}</span>
          </td>
          <td class=" justify-center align-content-center px-0">
            <span v-if="props.item.used_in_delegations > 0"
              >{{ $t("settings.project.assignedNDelegations", props.item.used_in_delegations, { count: props.item.used_in_delegations }) }} <br
            /></span>
            <span v-if="props.item.used_in_delegations === 0">{{ $t("settings.project.noAssignedDelegations") }}<br /></span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "SettingsProjectView",
  // components: { ExternalCompanyForm },
  data: () => ({
    projects: [],
    search: ""
  }),
  created() {
    this.load();
  },
  computed: {
    headers() {
      return [
        { text: this.$t("settings.project.headers.name"), value: "name" },
        { text: this.$t("settings.project.headers.contractorName"), value: "external_customer_name" },
        { text: this.$t("settings.project.headers.orderNumber"), value: "order_number" },
        {
          text: this.$t("settings.project.headers.isActive"),
          value: "is_enabled"
        },
        { text: this.$t("settings.project.headers.assignedDelegations"), value: "actions2", sortable: false }
        // { text: "", value: "actions", sortable: false }
      ];
    },
    hasPermissionForEdit() {
      return this.$store.getters.hasPermission("SuperAdmin") || this.$store.getters.hasPermission("companyAdmin");
    }
  },
  methods: {
    load() {
      this.axios.get("settings/project/list").then(response => {
        this.projects = response.data;
      });
    }
  }
};
</script>

<style scoped></style>
